import * as React from "react";
function SvgIcArrowR(props) {
  return <svg width="1em" height="1em" viewBox="0 0 26 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path opacity={0.4} d="M1 7h24l-5.333-6" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default SvgIcArrowR;